import { Client } from 'urql';
import { formatChildPath, formatPathnameToSchoolSlug } from '../helpers/formatPathnameToSchoolSlug';
import { schoolPageBySlugQuery } from './schoolPageBySlugQuery';

interface FetchSchoolPageBySlug {
  client: Client;
  pathname: string;
  schoolId: string;
  childPath?: string;
}

export const fetchSchoolPageBySlug = async ({
  client,
  pathname,
  schoolId,
  childPath,
}: FetchSchoolPageBySlug) => {
  const { data, error } = await client
    .query(schoolPageBySlugQuery, {
      slug: formatPathnameToSchoolSlug(pathname, childPath),
      id: schoolId,
      path: formatChildPath(childPath),
    })
    .toPromise();
  return { data, error };
};
